import {getRequest} from '@requests/index';
import {loadingApplication, addNotification, openWrongPage} from '@componentDP/js_react/redux/actions/application';
import {setProfileBasic} from '@componentDP/js_react/redux/actions/profile_basic';
import {mappingSettings} from '@helpers/mapping_fields';
import {DIGITAL_PROFILE_SETTINGS, DIGITAL_PROFILE_CABINET_LOADED} from '../store/actionTypes';
import {store} from '../store';

export function initDigitalProfileCabinet() {
    return async (dispatch) => {
        dispatch(loadingApplication(true));
        const {apiDomainVikon} = store.getState();
        const chainPromises = [
            getRequest(`${apiDomainVikon}api/digital_profile/settings`),
            getRequest(`${apiDomainVikon}api/digital_profile/applicant`),
        ];
        Promise.all(chainPromises)
            .then(async (values) => {
                const [digitalProfileSettings, profileBasic] = values;
                if (profileBasic.hasOwnProperty('errors')) {
                    throw new Error(profileBasic.errors);
                }
                if (digitalProfileSettings.hasOwnProperty('errors')) {
                    throw new Error(digitalProfileSettings.errors);
                }
                dispatch(setProfileBasic(profileBasic));
                dispatch(setDigitalProfileSettings(digitalProfileSettings));
                dispatch(setDigitalProfileCabinetLoaded(true));
                dispatch(loadingApplication(false));
            })
            .catch((e) => {
                dispatch(addNotification({message: e.message, type: 'error'}));
                dispatch(openWrongPage());
            });
    };
}

export function setDigitalProfileSettings(settings) {
    const settingsMapped = mappingSettings(settings);
    return {
        type: DIGITAL_PROFILE_SETTINGS,
        object: settingsMapped,
    };
}

export function setDigitalProfileCabinetLoaded(status) {
    return {
        type: DIGITAL_PROFILE_CABINET_LOADED,
        status,
    };
}
